import React from 'react';
import { WHITE_LABEL_CONFIG } from './white_label';

const SandboxBanner = () => {
  if (!WHITE_LABEL_CONFIG.isSandboxMode) {
    return null;
  }

  return (
    <div className="sticky top-0 z-50 border-b border-amber-500/40 bg-amber-900/90 bg-[repeating-linear-gradient(-45deg,rgba(251,191,36,0.22)_0_12px,rgba(255,255,255,0.06)_12px_24px)] px-4 py-2 text-center text-[0.72rem] font-semibold uppercase tracking-[0.28em] text-amber-50 shadow-[0_10px_24px_rgba(120,53,15,0.24)] backdrop-blur-sm sm:text-[0.78rem]">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-3">
        <span className="inline-flex h-2.5 w-2.5 shrink-0 rounded-full bg-amber-300 animate-pulse"></span>
        <span>SANDBOX ENVIRONMENT</span>
      </div>
    </div>
  );
};

export default SandboxBanner;
